<template>
    <div class="uk-container uk-container-small uk-margin-xxlarge-bottom">
        <div class="news-grid uk-clearfix uk-child-width-1-2@m" uk-grid>
            <div class="news-grid-image">
                <img v-if="field.featuredImage && !field.featureVideoLink" class="news-image" :src="imageUrl" :alt="imageTitle">
                <div v-else-if="field.featuredImage && field.featureVideoLink" class="news-image" uk-lightbox>
                    <a v-if="isVideo(field.featureVideoLink)" :href="field.featureVideoLink" class="video-overlay">
                        <img :src="imageUrl" :alt="imageTitle">
                    </a>
                    <a v-else data-type="iframe" :href="field.featureVideoLink" class="video-overlay">
                        <img :src="imageUrl" :alt="imageTitle">
                    </a>
                </div>
            </div>
            <div class="news-grid-copy-wrapper" uk-parallax="y: 10%,-10%; media: @s; viewport: 1;">
                <div class="news-grid-copy">
                    <div class="news-grid-copy-inner">
                        <h3 class="uk-h2" :class="colourSlug" v-text="field.title"></h3>
                        <vue-markdown
                            v-fancy-letters.multiple="'a'"
                            :anchor-attributes="{
                            target: '_blank',
                            rel: 'nofollow'
                        }"
                        class="white">{{field.copy}}</vue-markdown>
                    </div>
                </div>
                <div class="news-linebreak">
                    <SquareLineBreak :class="colourSlug"></SquareLineBreak>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import VueMarkdown from 'vue-markdown'
import SquareLineBreak from '@/assets/img/sq-linebreak.svg'

Vue.use(VueMarkdown)

export default {
    props: ['sys', 'field'],
    components: {
        VueMarkdown,
        SquareLineBreak
    },
    computed: {
        imageUrl () {
            return this.field.featuredImage ? this.field.featuredImage.fields.file.url : ''
        },
        imageTitle () {
            return this.field.featuredImage ? this.field.featuredImage.fields.title : ''
        },
        colourSlug () {
            return this.field.titleColour ? this.field.titleColour.fields.colourSlug : ''
        }
    },
    methods: {
        isVideo (url) {
            let iframe = new URL(url)
            return iframe.host.includes('youtu') || iframe.host.includes('vimeo')
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/NewsItem.vue